import mpkBusinessTip from './mpkBusinessTip';
import personalAccount from './personalAccount';

export default {
  personalAccount,
  mpkBusinessTip,
};
